import * as React from "react";
import { compose } from "@grandvisionhq/utils";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import CmsBlogLayout from "../../../../layouts/layouts/Blog.js";
import CmsContentLayout from "../../../../layouts/layouts/Content.js";
const isBlogArticle = (content) => content.type === "blogArticle";
const CmsXPagesContent = ({ content, pageName }) => {
  let name = pageName;
  if (content.type === "brand") {
    name = "brand-detail";
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, isBlogArticle(content) ? /* @__PURE__ */ React.createElement(CmsBlogLayout, { content }) : /* @__PURE__ */ React.createElement(CmsContentLayout, { content, pageName: name, hasBreadcrumbs: false }));
};
const CmsXPagesContent$1 = compose(
  withHidableContent,
  withBloomreachData,
  withEditableContent
)(CmsXPagesContent);
export {
  CmsXPagesContent,
  CmsXPagesContent$1 as default
};
//# sourceMappingURL=XPagesContent.js.map
